import {
  OWNER_FILE_UPLOAD_FAILURE,
  OWNER_FILE_UPLOAD_REQUEST,
  OWNER_FILE_UPLOAD_SUCCESS,
} from "../constants";

const INITIAL_STATE = {
  isLoading: false,
  ownerUploadDocumentsData: {},
};

const uploadDocReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OWNER_FILE_UPLOAD_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case OWNER_FILE_UPLOAD_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case OWNER_FILE_UPLOAD_SUCCESS:
      return {
        ...state,
        ownerUploadDocumentsData: action.payload,
        isLoading: false,
      };
    default:
      return state;
  }
};

export default uploadDocReducer;
